import { render, staticRenderFns } from "./FormCreateAccount.vue?vue&type=template&id=1de47832&scoped=true&"
import script from "./FormCreateAccount.vue?vue&type=script&lang=js&"
export * from "./FormCreateAccount.vue?vue&type=script&lang=js&"
import style0 from "./FormCreateAccount.vue?vue&type=style&index=0&id=1de47832&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1de47832",
  null
  
)

export default component.exports